import CompanyLogo from '@/app/web-traffic-activity/CompanyLogo';
import { Link } from '@/components/typography';

type Props = {
  name: string;
  to?: string;
  domain: string;
};

const CompanyCell = ({ name, to, domain }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <div className="-my-2 flex w-6 items-center justify-center">
        <CompanyLogo size="medium" name={name} domain={domain} />
      </div>
      <Link to={to} variant="caption1">
        {name || domain}
      </Link>
    </div>
  );
};

export default CompanyCell;
